import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  taskId: string;
  data: any
}

const mutateUpdateSafetyCheck = async ({projectId, taskId, data}: mutateProps) => {
  return await axiosAuth.put(`${PROJECT_API}/${projectId}/tasks/${taskId}/safety-checks`, data);
};

const useUpdateSafetyCheckMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateUpdateSafetyCheck,
    ...queryParams,
  });

export default useUpdateSafetyCheckMutation;
